import React, { Component } from "react";
import logo from "../logo.png";

export default class Footer extends Component {
  state = {
    year: 2018
  };

  componentDidMount() {
    let time = new Date();
    this.setState({ year: time.getFullYear() });
  }

  render() {
    return (
      <footer className="footer front-end-footer">
        <article className="footer-content large-wrapper clearfix">
          <div className="col-xs-12 col-sm-6 col-lg-4">
            <img id="footer-logo" src={logo} alt="logo" />
          </div>

          <div className="col-xs-12 col-sm-6 col-lg-4">
            <p>
              &copy; {this.state.year} All rights reserved, Minerva Web
              Development, Inc.{" "}
            </p>
          </div>

          <div className="col-xs-12 col-sm-12 col-lg-4">
            <h3>Social Media</h3>
            <div className="social-media">
              <a
                href="https://facebook.com/MinervaWebDevelopment"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-facebook-square" />
              </a>
              <a
                href="https://www.instagram.com/minervawebdevelopment/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-linkedin" />
              </a>
              <a
                href="https://www.linkedin.com/company/minerva-web-development/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-instagram" />
              </a>
            </div>
          </div>
        </article>
      </footer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/includes/Footer.js